import styles from './NoItems.module.scss'
import React from 'react'

type Props = {}

const NoItems = (props: Props) => {
  return (
    <div className={styles.component}>
      No articles found...
    </div>
  )
}

export default NoItems